/** Pendant zu `Services/API/ApiBestellpositionService.cs`. */

import type { BestellpositionDivideDefinition } from '@/types/definitions';
import type { OrderPosition } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

import { buildAppPath } from '../apiBase';
import {
  createViewApi,
  postRecalculation,
  toMutationResult,
  type MutationResult,
  type ViewApi,
} from '../apiViewBase';
import { apiClient } from '../httpClient';

const ENDPOINT = 'bestellpositionen';

export const orderPositionApi: ViewApi<OrderPosition> & {
  reCalcContainer(viewId: number, position: OrderPosition): Promise<OrderPosition>;
  divide(viewId: number, definition: BestellpositionDivideDefinition): Promise<MutationResult>;
} = {
  ...createViewApi<OrderPosition>(ENDPOINT, EntityTypes.Bestellposition),

  // „Newkalkulieren“ ist der Originaltext des Altclients.
  reCalcContainer: (viewId, position) =>
    postRecalculation<OrderPosition>(
      `${buildAppPath(ENDPOINT)}/${viewId}/${position.Id}/recalcContainer`,
      'Fehler beim Newkalkulieren der Frachtkosten.',
    ),

  divide: async (viewId, definition) =>
    toMutationResult(
      await apiClient.raw('POST', `${buildAppPath(ENDPOINT)}/${viewId}/divide`, definition),
    ),
};
